import { render, staticRenderFns } from "./ChatRoomDialog.vue?vue&type=template&id=12d36cc3&"
import script from "./ChatRoomDialog.vue?vue&type=script&lang=js&"
export * from "./ChatRoomDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomDialog.vue?vue&type=style&index=0&id=12d36cc3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports